import React from 'react'
import classes from '../FitnessPreview.module.scss'
const PlayIconSvg = () => {
    return (<svg className={classes.video} width="26" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="36" height="36" rx="18" fill="#F2F7FB" />
        <path d="M12.334 17.9998V15.0332C12.334 11.3498 14.9423 9.8415 18.134 11.6832L20.709 13.1665L23.284 14.6498C26.4757 16.4915 26.4757 19.5082 23.284 21.3498L20.709 22.8332L18.134 24.3165C14.9423 26.1582 12.334 24.6498 12.334 20.9665V17.9998Z" stroke="#3ECAE3" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
    </svg>)
}

export default PlayIconSvg;